module.exports = __webpack_public_path__ + "img/secondary_3x3.d570c786.svg";